var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 69,
    rx: 4.5,
    fill: "#007AFF",
    fillOpacity: 0.05,
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2869 39.0738C45.5524 36.7069 43.1514 34.9116 40.3446 33.8827L40.0983 33.7929L40.3116 33.6441C41.4391 32.8565 42.3754 31.8152 43.0183 30.6335C43.6833 29.4119 44.0341 28.0348 44.0341 26.6508C44.0341 21.8805 39.9816 18 35 18C30.0184 18 25.9652 21.8805 25.9652 26.6508C25.9652 28.0348 26.3167 29.4119 26.981 30.6335C27.6246 31.8152 28.5602 32.8565 29.6884 33.6441L29.901 33.7929L29.6554 33.8827C26.8479 34.9116 24.4476 36.7069 22.7124 39.0738C20.9378 41.4956 20 44.3411 20 47.3031C20 49.8928 22.1998 52 24.9043 52H45.095C47.7995 52 50 49.8928 50 47.3031C50 44.3411 49.0615 41.4956 47.2869 39.0738ZM28.4328 26.6508C28.4328 23.1829 31.3785 20.3622 35 20.3622C38.6215 20.3622 41.5672 23.1829 41.5672 26.6508C41.5672 30.1187 38.6215 32.9394 35 32.9394C31.3785 32.9394 28.4328 30.1187 28.4328 26.6508ZM45.095 49.6371H24.9043C23.5607 49.6371 22.4668 48.5904 22.4668 47.3031C22.4668 40.6854 28.0891 35.3016 35 35.3016C41.9109 35.3016 47.5332 40.6854 47.5332 47.3031C47.5332 48.5904 46.4393 49.6371 45.095 49.6371Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers1);
export default __webpack_public_path__ + "static/media/Users (1).fc2d658f72f4048cec2004da43636372.svg";
export { ForwardRef as ReactComponent };